<template>
  <div class="szw-row szw-gap-1 szw-overflow-auto szw-relative hide-scrollbar">
    <!-- SINGLE TAB -->
    <div
      :class="['szw-min-w-16 szw-h-8 szw-rounded', themeVersion === 'current' ? 'szw-bg-section-static' : 'szw-bg-background-color-secondary', classes]"
      v-for="tab of tabsNumber"
      :key="tab"
    />
  </div>
</template>

<script setup>
import { inject } from 'vue'

defineProps({
  tabsNumber: {
    type: Number,
    default: 10
  },
  classes: {
    type: String,
    default: ''
  }
})

const themeVersion = inject('themeVersion', 'current')
</script>
